import API from '../../services/API'
import {
    SPEECHES_GETTER,
    SPEECHES_TYPE_DEATH_NOTICE,
    SPEECHES_TYPE_BURIAL_SPEECH,
    SPEECHES_TYPE_CEREMONY_SPEECH,
    SPEECHES_MUTATION_SINGLE_ENTRY,
    SPEECHES_MUTATION_ENTIRE_SPEECHES,
    SPEECHES_MUTATION_FILE,
    SPEECHES_ACTION_GET_SPEECHES,
    SPEECHES_ACTION_SAVE_SPEECHES,
    SPEECHES_ACTION_SAVE_FILE,
    FILE_GETTER
} from './speeches-types'

import Vue from 'vue'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        speeches: {}
    },

    getters: {
        [SPEECHES_GETTER]: state => state.speeches,
        [FILE_GETTER]: (state) => (payload) => {
            if (state.speeches.created == null) {
                return ''
            }
            switch (payload) {
            case SPEECHES_TYPE_DEATH_NOTICE:
                return state.speeches.deathNoticeFile
            case SPEECHES_TYPE_BURIAL_SPEECH:
                return state.speeches.burialSpeechFile
            case SPEECHES_TYPE_CEREMONY_SPEECH:
                return state.speeches.ceremonySpeechFile
            default:
                return ''
            }
        }
    },

    mutations: {
        [SPEECHES_MUTATION_SINGLE_ENTRY] (state, payload) {
            let key = Object.keys(payload)[0]
            Vue.set(state.speeches, key, payload[key])
        },
        [SPEECHES_MUTATION_FILE] (state, payload) {
            switch (payload.category) {
            case SPEECHES_TYPE_DEATH_NOTICE:
                state.speeches.deathNoticeFile = payload.file
                break
            case SPEECHES_TYPE_BURIAL_SPEECH:
                state.speeches.burialSpeechFile = payload.file
                break
            case SPEECHES_TYPE_CEREMONY_SPEECH:
                state.speeches.ceremonySpeechFile = payload.file
                break
            default:
                return ''
            }
        },
        [SPEECHES_MUTATION_ENTIRE_SPEECHES] (state, payload) { state.speeches = payload }
    },

    actions: {
        [SPEECHES_ACTION_GET_SPEECHES] ({ commit }) {
            API.loadSpeeches()
                .then((documentsData) => { commit(SPEECHES_MUTATION_ENTIRE_SPEECHES, documentsData) })
                .catch((error) => console.log('' + error.message))
        },
        [SPEECHES_ACTION_SAVE_SPEECHES] ({commit, state}, payload) {
            API.saveSpeeches(payload)
                .then((documentsData) => {
                    OAlert.showSuccess('', i18n.t('feedback.speechesSucSave'))
                    commit(SPEECHES_MUTATION_ENTIRE_SPEECHES, documentsData)
                })
                .catch((error) => console.log(error.message))
        },
        [SPEECHES_ACTION_SAVE_FILE] ({commit, state}, payload) {
            let apiPayload = ''
            switch (payload.category) {
            case SPEECHES_TYPE_DEATH_NOTICE:
                apiPayload = {deathNoticeFile: payload.file}
                break
            case SPEECHES_TYPE_BURIAL_SPEECH:
                apiPayload = {burialSpeechFile: payload.file}
                break
            case SPEECHES_TYPE_CEREMONY_SPEECH:
                apiPayload = {ceremonySpeechFile: payload.file}
                break
            }
            API.saveSpeeches(apiPayload)
                .then((documentsData) => {
                    OAlert.showSuccess('', i18n.t('feedback.speechesSucSaveDelete'))
                    commit(SPEECHES_MUTATION_ENTIRE_SPEECHES, documentsData)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/speeches.js